import React, { useState, useEffect } from 'react';
import { Dropdown, Modal } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { courseAddBdi8Info, courseFlCounties, studentData } from 'dsoapi';
import NextGatherInfoUrl from './NextGatherInfoUrl';

const GatherInfoBDI8 = ({ uceId }) => {
  const [citationNumber, setCitationNumber] = useState('');
  const [counties, setCounties] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [dlNumber, setDlNumber] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [showCitationModal, setShowCitationModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const flCountiesPromise = courseFlCounties();
      const studentDataPromise = studentData();
      const flCountiesResp = await flCountiesPromise;
      const studentResp = await studentDataPromise;
      setCounties(flCountiesResp.data);
      setDlNumber(studentResp.data.driverLicenseNumber);
    };
    fetchData();
  }, [uceId]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setShowValidation(true);
    const { isValid: validDl } = validateDLField();
    const { isValid: validCitation } = validateCitationNumber();
    if (validCitation && selectedCounty && validDl) {
      setSubmitting(true);
      const request = {
        citationNumber,
        countyReceived: selectedCounty,
        driverLicenseNumber: dlNumber,
      };
      await courseAddBdi8Info(uceId, request);
      const url = await NextGatherInfoUrl(uceId);
      setSubmitting(false);
      navigate(url);
    }
  };

  function validateDLField() {
    if (dlNumber.length < 1) {
      return {
        isValid: false,
        message: 'Driver license number is required',
      };
    }
    return {
      isValid: true,
      message: '',
    };
  }

  function validateCitationNumber() {
    if (citationNumber.length < 1) {
      return {
        isValid: false,
        message: 'Citation number is required',
      };
    }
    return {
      isValid: true,
      message: '',
    };
  }

  return (
    <form className="ui form" onSubmit={onSubmit}>
      <div className="ui container">
        <h4 className="ui dividing header">Enter BDI8 Information</h4>
        <div className="ui stackable grid">
          <div className="eight wide column">
            <div className="field">
              <label htmlFor="citationNumber">Citation Number</label>
              <div className="ui icon input">
                <input
                  name="citationNumber"
                  placeholder="Citation Number"
                  value={citationNumber}
                  onChange={(e) => setCitationNumber(e.target.value)}
                />
                <i
                  className="question circle link icon"
                  onClick={() => setShowCitationModal(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              {showValidation && !validateCitationNumber().isValid && (
                <p className="error">{validateCitationNumber().message}</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="countyReceived">County Received</label>
              <Dropdown
                name="countyReceived"
                style={{ maxHeight: '27rem' }}
                placeholder="Select county received"
                fluid
                selection
                options={counties}
                value={selectedCounty}
                onChange={(_, { value }) => setSelectedCounty(value)}
              />
              {showValidation && !selectedCounty && (
                <p className="error">county received is required</p>
              )}
            </div>
          </div>
          <div className="eight wide column">
            <div className="field">
              <label htmlFor="dlNumber">Drivers License Number</label>
              <input
                name="dlNumber"
                placeholder="Drivers License Number"
                value={dlNumber}
                onChange={(e) => setDlNumber(e.target.value)}
              />
              {showValidation && !validateDLField().isValid && (
                <p className="error">{validateDLField().message}</p>
              )}
            </div>
            <input
              className="ui primary button"
              type="submit"
              value={submitting ? 'Submitting...' : 'Submit'}
              disabled={submitting}
            />
          </div>
        </div>
      </div>
      <Modal
        open={showCitationModal}
        onClose={() => setShowCitationModal(false)}
        size="large"
      >
        <Modal.Header>
          How do I locate my citation number or case number?
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <h3>Citation Number</h3>
            <p>
              The citation number will be on your copy of the traffic ticket. It
              should be on the top right corner of the ticket, as shown circled
              in red on this sample picture below. This number is needed to
              electronically report your traffic school completion to the FL DMV
              or Clerk of Court. If certain numbers/letters are difficult to
              read (such as the letter "O" or the number zero), you should
              contact the court to confirm. Incorrect ticket information could
              result in a $5 re-reporting fee. Citation numbers are 7 characters
              in length. In this example, the citation number is ABC1234.
            </p>
            <div className="ui fluid image">
              <img
                src="https://static-content.fedsafe.com/images/helppage/citation_number.png"
                alt="Citation Number"
                className="ui image"
              />
            </div>
            <h3>Case Number</h3>
            <p>
              You can also enter in your Court Case Number. Court Case numbers
              are much longer than a citation number, generally a minimum of 9
              characters. Here are some examples of case number formatting.
            </p>
            <p>Example:</p>
            <ul>
              <li>2025TR123456</li>
              <li>25000123TRAXMX</li>
              <li>25-12345-TR</li>
              <li>25001234TI30A</li>
              <li>25-CT-123456</li>
            </ul>
            <p>
              *If you are not able to locate the citation or case number, please
              contact the clerk of the court traffic division from the county
              you received the ticket. They will be able to provide it for you.
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="ui button"
            onClick={() => setShowCitationModal(false)}
          >
            Close
          </button>
        </Modal.Actions>
      </Modal>
    </form>
  );
};

export default GatherInfoBDI8;
